import { State } from '../../types';

export const washington: State = {
  name: 'Washington',
  abbreviation: 'WA',
  terms: [
    {
      word: 'Chehalis',
      phonetic: 'shuh-HAY-lis',
      // audioUrl: '/audio/chehalis.mp3',
      description: 'A city in Lewis County, pronounced "shuh-HAY-lis," not "CHEE-hal-is."'
    },
    {
      word: 'Cheney',
      phonetic: 'CHEE-nee',
      // audioUrl: '/audio/cheney.mp3',
      description: 'A city in Spokane County, pronounced "CHEE-nee," not "CHEY-nee."'
    },
    {
      word: 'Issaquah',
      phonetic: 'ISS-uh-kwah',
      // audioUrl: '/audio/issaquah.mp3',
      description: 'A city in King County, pronounced "ISS-uh-kwah," not "ISS-uh-quah."'
    },
    {
      word: 'Puyallup',
      phonetic: 'pyoo-AL-up',
      // audioUrl: '/audio/puyallup.mp3',
      description: 'A city in Pierce County, pronounced "pyoo-AL-up," not "pyoo-ALL-up."'
    },
    {
      word: 'Sequim',
      phonetic: 'skwim',
      // audioUrl: '/audio/sequim.mp3',
      description: 'A city in Clallam County, pronounced "skwim," not "SEE-kwim."'
    },
    {
      word: 'Spokane',
      phonetic: 'spoh-KAN',
      // audioUrl: '/audio/spokane.mp3',
      description: 'A city in eastern Washington, pronounced "spoh-KAN," not "spoh-KANE."'
    },
    {
      word: 'Steilacoom',
      phonetic: 'STILL-uh-come',
      // audioUrl: '/audio/steilacoom.mp3',
      description: 'A town in Pierce County, pronounced "STILL-uh-come," not "STEE-lah-coom."'
    },
    {
      word: 'Snohomish',
      phonetic: 'snoh-HOH-mish',
      // audioUrl: '/audio/snohomish.mp3',
      description: 'A city and county in Washington, pronounced "snoh-HOH-mish," not "snoh-HOE-mish."'
    },
    {
      word: 'Snoqualmie',
      phonetic: 'snoh-KWALL-mee',
      // audioUrl: '/audio/snoqualmie.mp3',
      description: 'A city in King County, pronounced "snoh-KWALL-mee," not "snoh-KWAL-mee."'
    },
    {
      word: 'Wenatchee',
      phonetic: 'weh-NATCH-ee',
      // audioUrl: '/audio/wenatchee.mp3',
      description: 'A city in Chelan County, pronounced "weh-NATCH-ee," not "weh-NATCH-ay."'
    },
    {
      word: 'Yakima',
      phonetic: 'YAK-ih-mah',
      // audioUrl: '/audio/yakima.mp3',
      description: 'A city in central Washington, pronounced "YAK-ih-mah," not "YAK-ih-muh."'
    }
  ]
};